import { baseApiClient } from '../../api/BaseApiClient';

export const resendVerificationEmail = async (id: string) => {
  return await baseApiClient.post('/v1/verify-email/', { sub: id });
};
